export const thridPartyMeasurementTrackingStyles = {
  thirdPartyMeasurementGuide: {
    root: {
      ' .ms-Label': {
        fontSize: 14,
        fontWeight: 400,
      },
      lineHeight: 20,
    },
  },

  thirdPartyMeasurementRemoveAllStack: {
    root: {
      height: 0,
    },
  },

  thirdPartyMeasurementRemoveAllButton: {
    label: { color: '#424242', fontWeight: 600 },
    root: {
      marginTop: 16,
      height: 31,
      // Fix the focus wrapping un-complete issue in desert mode
      '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
        '&:focus::after': {
          inset: '0px !important',
        },
      },
    },
  },

  thirdPartyMeasurementAddButton: {
    label: { color: '#0078D4', fontWeight: 600 },
    icon: { fontSize: 14, fontWeight: 400 },
    root: {
      verticalAlign: 'middle',
      // Fix the focus wrapping un-complete issue in desert mode
      '@media screen and (-ms-high-contrast: active), screen and (forced-colors: active)': {
        '&:focus::after': {
          inset: '0px !important',
        },
      },
    },
    dropdown: {
      root: {
        width: 312,
        ' .ms-ContextualMenu-header': {
          paddingLeft: 8,
          fontSize: 12,
          fontWeight: 600,
          color: '#616161',
        },
        ' .ms-ContextualMenu-link': {
          paddingLeft: 28,
          fontSize: 14,
          fontWeight: 400,
          lineHeight: 20,
        },
      },
    },
  },

  thirdPartyMeasurementVendorSettings: {
    root: {
      justifyContent: 'space-between',
      alignItems: 'center',
      ' .vendor-settings': {
        ' .third-party-measurement-vendor': {
          marginLeft: 10,
          marginRight: 10,
          paddingTop: 31,
          ' .ms-TextField-field': {
            width: 215,
            height: 32,
          },
          ' label': {
            fontWeight: 400,
          },
        },

        ' .ispot-brand-id': {
          marginLeft: 10,
          marginRight: 10,
          ' .ms-TextField-field': {
            width: 215,
            height: 32,
          },
          ' label': {
            fontWeight: 400,
          },
        },
        ' .account-linked-status': {
          paddingTop: 30,
        },
      },
      ' .third-party-measurement-remove-button': {
        paddingTop: 30,
      },
    },
  },

  thirdPartyMeasurementRemoveButton: {
    icon: { fontSize: 14, fontWeight: 400, color: '#424242' },
    root: { verticalAlign: 'middle', marginRight: 27 },
  },

  warningMessageContainer: {
    root: {
      marginTop: 16,
      padding: 8,
    },
  },

  warningMessage: {
    backgroundColor: '#F5F5F5',
    border: '1px solid',
    paddingInline: 12,
    verticalAlign: 'middle',
    borderRadius: 4,
    borderColor: '#D1D1D1',
    gap: 8,
    height: 36,
    icon: {
      color: '#616161',
      fontSize: 20,
      height: 20,
      width: 20,
      fontWeight: 400,
      marginTop: 2,
    },
  },

  warningMessageText: {
    root: {
      fontWeight: 400,
    },
  },

  label: options => ({
    color: options.linked ? '#115EA3' : '#8A3707',
    backgroundColor: options.linked ? '#EBF3FC' : '#FDCFB4',
    borderColor: options.linked ? '#B4D6FA' : '#FFF9F5',
    fontWeight: 600,
    fontSize: 12,
    border: '1px solid',
    verticalAlign: 'middle',
    borderRadius: 99,
    height: 20,
    minWidth: 24,
    paddingInline: 5,
    paddingTop: 1,
    paddingBottom: 3,
    marginLeft: 8,
    marginRight: 8,
  }),
};
